(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-atacado"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	const isDesktop = window.matchMedia('(min-width: 1100px)').matches;
	const hasScrolledPastHeader = isDesktop ? scrollTop > 0 : scrollTop > this.headerBounds.bottom;
	const isAtTop = isDesktop ? scrollTop <= 0 : scrollTop <= this.headerBounds.top;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-2');
		this.header.style.transition = 'background var(--duration-short)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-2');
		};
	};

	if (scrollTop > this.currentScrollTop && hasScrolledPastHeader) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && hasScrolledPastHeader) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (isAtTop) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	getDesktopLogoState() {
		if (!window.matchMedia('(min-width: 1100px)').matches || !this.header) return null;
		const logo = this.header.querySelector('.header__heading-link');
		return logo ? { logo, rect: logo.getBoundingClientRect() } : null;
	}

	animateDesktopLogo(state) {
		if (!state || typeof state.logo.animate !== 'function') return;
		const nextRect = state.logo.getBoundingClientRect();
		const deltaX = state.rect.left - nextRect.left;

		if (Math.abs(deltaX) < 1) return;

		if (typeof state.logo.getAnimations === 'function') {
			state.logo.getAnimations().forEach((animation) => animation.cancel());
		}
		state.logo.animate(
			[
				{ transform: `translateX(${deltaX}px)` },
				{ transform: 'translateX(0)' }
			],
			{
				duration: 400,
				easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
				fill: 'none'
			}
		);
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;		
		if (document.querySelector(".overflow-hidden-tablet")) return;
		const isDesktop = window.matchMedia('(min-width: 1100px)').matches;
		const logoState = this.getDesktopLogoState();
		if (isDesktop) {
			this.header.classList.add('header--compact', 'shopify-section-header-sticky');
			this.header.classList.remove('shopify-section-header-hidden');
		} else {
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		}
		this.animateDesktopLogo(logoState);
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		const isDesktop = window.matchMedia('(min-width: 1100px)').matches;
		const logoState = this.getDesktopLogoState();
		if (isDesktop) {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('header--compact', 'shopify-section-header-hidden');
		} else if (document.querySelector('.entering-section')) {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}
		else{
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden','color-background-2');
		}
		this.animateDesktopLogo(logoState);
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		const logoState = this.getDesktopLogoState();
		this.header.classList.remove('header--compact', 'shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-2');
		};
		this.animateDesktopLogo(logoState);
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isDesktop = window.matchMedia('(min-width: 1100px)').matches;
      const hasScrolledPastHeader = isDesktop ? scrollTop > 0 : scrollTop > this.headerBounds.bottom;
      const isAtTop = isDesktop ? scrollTop <= 0 : scrollTop <= this.headerBounds.top;

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
        this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-always-sticky');
        this.header.style.transform = 'translateY(-100%)';
      }

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
        this.header.classList.remove('color-background-2');
        this.header.style.transition = 'background var(--duration-short)';
        this.header.style.transform = 'translateY(0)';
      }

      if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('shopify-section-header-sticky');
        this.header.style.transform = 'translateY(0)';
        this.header.style.transition = 'background var(--duration-short)';
        if (this.header.classList.contains('color-background-1')) {
          this.header.classList.add('color-background-2');
        }
      }

      if (scrollTop > this.currentScrollTop && hasScrolledPastHeader) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && hasScrolledPastHeader) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (isAtTop) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    getDesktopLogoState() {
      if (!window.matchMedia('(min-width: 1100px)').matches || !this.header) return null;
      const logo = this.header.querySelector('.header__heading-link');
      return logo ? { logo, rect: logo.getBoundingClientRect() } : null;
    }

    animateDesktopLogo(state) {
      if (!state || typeof state.logo.animate !== 'function') return;
      const nextRect = state.logo.getBoundingClientRect();
      const deltaX = state.rect.left - nextRect.left;

      if (Math.abs(deltaX) < 1) return;

      if (typeof state.logo.getAnimations === 'function') {
        state.logo.getAnimations().forEach((animation) => animation.cancel());
      }
      state.logo.animate([{ transform: `translateX(${deltaX}px)` }, { transform: 'translateX(0)' }], {
        duration: 400,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        fill: 'none',
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (document.querySelector('.overflow-hidden-tablet')) return;
      const isDesktop = window.matchMedia('(min-width: 1100px)').matches;
      const logoState = this.getDesktopLogoState();
      if (isDesktop) {
        this.header.classList.add('header--compact', 'shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');
      } else {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }
      this.animateDesktopLogo(logoState);
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      const isDesktop = window.matchMedia('(min-width: 1100px)').matches;
      const logoState = this.getDesktopLogoState();
      if (isDesktop) {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('header--compact', 'shopify-section-header-hidden');
      } else if (document.querySelector('.entering-section')) {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      } else {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden', 'color-background-2');
      }
      this.animateDesktopLogo(logoState);
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      const logoState = this.getDesktopLogoState();
      this.header.classList.remove(
        'header--compact',
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
      if (this.header.classList.contains('color-background-1')) {
        this.header.classList.add('color-background-2');
      }
      this.animateDesktopLogo(logoState);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (this.disclosures) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }
      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      if (this.disclosureLists) {
        this.disclosureLists.forEach((disclosureList) => {
          disclosureList.setAttribute('hidden', true);
        });
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  //class CartNote extends HTMLElement {
  //  constructor() {
  //    super();

  //    this.addEventListener(
  //      'change',
  //      debounce((event) => {
  //        const body = JSON.stringify({ note: event.target.value });
  //        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  //      }, 300)
  //    );
  //  }
  //}

  //customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();

      this.isProductPage = true;
    }

    hide() {
      super.hide(this.isProductPage);
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      if (activeMedia) {
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
      }
      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
